import Image from "next/image"

interface CategoryDetailsProps {
  name: string
  description: string
  imageUrl: string
}

export function CategoryDetails({
  name,
  description,
  imageUrl,
}: CategoryDetailsProps) {
  return (
    <div className="flex items-start gap-6 rounded-xl bg-secondary bg-[url('/banner/product-bg.svg')] bg-[length:200%] bg-top bg-no-repeat p-4 md:p-7">
      {imageUrl && (
        <div className="hidden shrink-0 rounded-lg bg-white p-5 md:block">
          <Image
            src={imageUrl}
            alt={name}
            className="object-cover"
            width={48}
            height={48}
          />
        </div>
      )}
      <div className="space-y-4">
        <div className="flex items-center gap-2">
          {imageUrl && (
            <div className="shrink-0 rounded-lg bg-white p-5 md:hidden">
              <Image
                src={imageUrl}
                alt={name}
                className="object-cover"
                width={48}
                height={48}
              />
            </div>
          )}
          <h1 className="text-white">{name}</h1>
        </div>
        <p className="text-base leading-7 text-white">{description}</p>
      </div>
    </div>
  )
}
